import { useDialog } from 'common/hooks/useDialog';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { useMortgageRefinanceState } from 'components/flows/mortgageRefinance/state/useMortgageRefinanceState';
import { useMortgageRefinanceProcessQuery } from 'generated/graphql';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import {
  MortgageRefinancePreviewDialogProps,
  MortgageRefinanceProductPreviewDialog,
} from './MoneyhoonProcessPreviewDialog/MortgageRefinancePreviewDialog';
import { ProductCard } from './ProductCard/ProductCard';

interface Props {
  id?: string;
}

export const MortgageRefinanceHomepageCard: React.FC<Props> = ({ id }) => {
  const { t } = useTranslation();
  const { isAuthenticated } = useContext(AuthContext);
  const { state } = useMortgageRefinanceState();

  const { data, loading } = useMortgageRefinanceProcessQuery({
    skip: !isAuthenticated || !id,
    variables: {
      id: id ?? '',
    },
  });

  const progress = isAuthenticated ? data?.process.inquiry?.inquiryProgress : state.meta?.progress;

  const updateTimestamp = isAuthenticated ? data?.process.updateTimestamp : state.meta?.updateTimestamp;

  const accepted = !!data?.process.acceptedProposal?.id;

  const handleRefinanceClick = async () => {
    processProductPreviewDialog.create({ id });
  };

  const processProductPreviewDialog = useDialog<MortgageRefinancePreviewDialogProps, void>(
    MortgageRefinanceProductPreviewDialog,
    {
      id,
      instanceId: 'mortgage-refinance-product-preview-dialog',
      navigable: true,
    },
  );

  return (
    <ProductCard
      accepted={accepted}
      color="red"
      loading={loading}
      onClick={handleRefinanceClick}
      progress={progress}
      title={t('products:cards.refinanceMortgage.title')}
      updateDate={updateTimestamp}
    />
  );
};
